export function CollapseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66602 7.99999C2.66602 7.75452 2.865 7.55554 3.11046 7.55554H12.8882C13.1337 7.55554 13.3327 7.75452 13.3327 7.99999C13.3327 8.24545 13.1337 8.44443 12.8882 8.44443H3.11046C2.865 8.44443 2.66602 8.24545 2.66602 7.99999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99913 1.33331C8.2446 1.33331 8.44358 1.5323 8.44358 1.77776V6.2222C8.44358 6.46767 8.2446 6.66665 7.99913 6.66665C7.75367 6.66665 7.55469 6.46767 7.55469 6.2222V1.77776C7.55469 1.5323 7.75367 1.33331 7.99913 1.33331Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.90751 4.13017C6.08107 3.95661 6.36249 3.95661 6.53604 4.13017L7.99955 5.59369L9.46307 4.13017C9.63662 3.95661 9.91804 3.95661 10.0916 4.13017C10.2652 4.30374 10.2652 4.58515 10.0916 4.75872L8.31382 6.53649C8.14027 6.71004 7.85884 6.71004 7.68529 6.53649L5.90751 4.75872C5.73395 4.58515 5.73395 4.30374 5.90751 4.13017Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99913 9.33331C8.2446 9.33331 8.44358 9.53229 8.44358 9.77776V14.2222C8.44358 14.4677 8.2446 14.6666 7.99913 14.6666C7.75367 14.6666 7.55469 14.4677 7.55469 14.2222V9.77776C7.55469 9.53229 7.75367 9.33331 7.99913 9.33331Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68529 9.46348C7.85884 9.28992 8.14027 9.28992 8.31382 9.46348L10.0916 11.2413C10.2652 11.4148 10.2652 11.6962 10.0916 11.8698C9.91804 12.0433 9.63662 12.0433 9.46307 11.8698L7.99955 10.4063L6.53604 11.8698C6.36249 12.0433 6.08107 12.0433 5.90751 11.8698C5.73395 11.6962 5.73395 11.4148 5.90751 11.2413L7.68529 9.46348Z"
        fill="currentColor"
      />
    </svg>
  );
}
